import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import MfaSetup from '../views/MfaSetup.vue';
import MfaVerify from '../views/MfaVerify.vue';
import Memberships from '../views/Memberships.vue';
import MyDownloads from '../views/MyDownloads.vue';
import Payments from '../views/Payments.vue';
import Pets from '../views/Pets.vue';
import PlanDetails from '../views/PlanDetails.vue';
import Plans from '../views/Plans.vue';
import PlanRanking from '../views/PlanRanking.vue';
import ContractRanking from '../views/ContractRanking.vue';
import ServiceRanking from '../views/ServiceRanking.vue';
import ContractProfitability from '../views/ContractProfitability.vue';
import CacCltv from '../views/CacCltv.vue';
import B2cCltv from '../views/B2cCltv.vue';
import MetricasMascotas from '../views/MetricasMascotas.vue';
import NewMrrReport from '../views/NewMrrReport.vue';
import Renovaciones from '../views/Renovaciones.vue';
import ContractSuccess from '../views/ContractSuccess.vue';
import Users from '../views/Users.vue';
import Companies from '../views/Companies.vue';
import ClientOrgCharts from '../views/ClientOrgCharts.vue';
import ClientOrgChartDetail from '../views/ClientOrgChartDetail.vue';
import ClientOrgChartUnassigned from '../views/ClientOrgChartUnassigned.vue';
import ServicesRecords from '../views/ServicesRecords.vue';
import RegisterRefund from '../views/RegisterRefund.vue';
import CreateUser from '../views/CreateUser.vue';
import ClinicOnboarding from '../views/ClinicOnboarding.vue';
import DroopyClinics from '../views/DroopyClinics.vue';
import DroopyClinicServices from '../views/DroopyClinicServices.vue';
import MRRDetalle from '../views/MrrDetalle.vue';
import MrrDaily from '../views/MrrDaily.vue';
import B2CReportV2 from '../views/B2CReportV2.vue';
import TipoCambio from '../views/TipoCambio.vue';
import AddPet from '../views/AddPet.vue';
import RefundView from '../views/RefundView.vue';
import RefundClinics from '../views/RefundClinics.vue';
import RefundRedirectProfiles from '../views/RefundRedirectProfiles.vue';
import Data from '../views/Data.vue';
import CompanyDetails from '../views/CompanyDetails.vue';
import Vision360 from '../views/Vision360.vue'
import Contratos from '../views/Contratos.vue'
import Productos from '../views/Productos.vue'
import LineasNegocio from '../views/LineasNegocio.vue'
import Brokers from '../views/Brokers.vue'
import RespuestasTipo from '../views/RespuestasTipo.vue'
import Servicios from '../views/Servicios.vue'
import Metas from '../views/Metas.vue'
import Ejecutivos from '../views/Ejecutivos.vue'
import BillingIndividual from '../views/BillingIndividual.vue'
import BillingImportar from '../views/BillingImportar.vue'
import ShelterPets from '../views/ShelterPets.vue'
import MetricasCES from '../views/MetricasCES.vue'
import MetricasReembolsos from '../views/MetricasReembolsos.vue'
import MetricasPetmed from '../views/MetricasPetmed.vue'
import SponsorshipMetrics from '../views/SponsorshipMetrics.vue'
import ClubDescuentos from '../views/ClubDescuentos.vue'
import PosterAds from '../views/PosterAds.vue'
import CargasMasivas from '../views/CargasMasivas.vue'
import FullContractRenewal from '../views/FullContractRenewal.vue'
import CoTutores from '../views/CoTutores.vue'
import Vencimientos from '../views/Vencimientos.vue'
import OppositionRequests from '../views/OppositionRequests.vue'
import InternalTools from '../views/InternalTools.vue'
import TermsNotification from '../views/TermsNotification.vue'
import Profile from '../views/Profile.vue'
import NoAccess from '../views/NoAccess.vue'
import { NO_ACCESS_PATH } from '../utils/nav-sections.utils'
import { permissionGuard } from './permission-guard'
import Cotizador from '../views/Cotizador.vue'
import Cotizaciones from '../views/Cotizaciones.vue'
import CotizacionDetalle from '../views/CotizacionDetalle.vue'
import AnalisisActuarial from '../views/AnalisisActuarial.vue';
import ClinicBilling from '../views/ClinicBilling.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // Top-level, outside the Home shell: these run on the enrollment token, which
  // Home's getUserData() guard would (correctly) reject.
  {
    path: '/mfa/setup',
    name: 'MfaSetup',
    component: MfaSetup
  },
  {
    path: '/mfa/verify',
    name: 'MfaVerify',
    component: MfaVerify
  },
  {
    path: '/',
    name: 'Usuarios',
    component: () => import('../views/Home.vue'),
    children: [
      {
        path: '/profile',
        name: 'Perfil',
        component: Profile
      },
      {
        path: NO_ACCESS_PATH,
        name: 'Sin acceso',
        component: NoAccess
      },
      {
        path: '/users',
        name: 'Users',
        component: Users,
        meta: { permission: 'users:view' }
      },
      {
        path: '/users/create-user',
        name: 'Crear Usuario',
        component: CreateUser,
        meta: { permission: 'users:create' }
      },
      {
        path: '/clinics/onboarding',
        name: 'Clínicas Droopy',
        component: ClinicOnboarding,
        meta: { permission: 'droopy-clinics:create' }
      },
      {
        path: '/clinics/droopy',
        name: 'Droopy',
        component: DroopyClinics,
        meta: { permission: 'droopy-clinics:view' }
      },
      {
        path: '/clinics/droopy/:clinicId/services',
        name: 'Servicios de clínica Droopy',
        component: DroopyClinicServices,
        props: true,
        meta: { permission: 'droopy-clinics:view' }
      },
      {
        path: '/data',
        name: 'Users',
        component: Data,
        // Aviso de sección movida: lo ve quien tiene alguna de las secciones a las que apunta.
        meta: { permission: ['customer-success:view', 'companies:view'] }
      },
      {
        path: '/siniestralidad',
        name: 'Siniestralidad',
        component: Users,
        meta: { permission: 'users:view' }
      },
      {
        path: '/services',
        name: 'Uso de servicios',
        component: Users,
        meta: { permission: 'users:view' }
      },
      {
        path: '/memberships',
        name: 'Companies',
        component: Memberships,
        meta: { permission: 'memberships:view' }
      },
      {
        path: '/memberships/:userId',
        name: 'Memberships by User',
        component: Memberships,
        meta: { permission: 'memberships:view' }
      },
      {
        path: '/my-downloads',
        name: 'MyDownloads',
        component: MyDownloads,
        meta: { permission: 'my-downloads:view' }
      },
      {
        path: '/pets',
        name: 'Pets',
        component: Pets,
        meta: { permission: 'pets:view' }
      },
      {
        path: '/pets/:userId',
        name: 'Pets by User',
        component: Pets,
        meta: { permission: 'pets:view' }
      },
      {
        path: '/memberships/:userId/add',
        name: 'AddPet',
        component: AddPet,
        props: true,
        meta: { permission: 'users:add-pet' }
      },
      {
        path: '/dxp',
        name: 'Solicitud DxP',
        component: Pets,
        meta: { permission: 'pets:view' }
      },
      {
        path: '/sponsorships',
        name: 'Apadrinamiento',
        component: Pets,
        meta: { permission: 'pets:view' }
      },
      {
        path: '/sponsorships/shelter-pets',
        name: 'Mascotas Apadrinamiento',
        component: ShelterPets,
        meta: { permission: 'shelter-pets:view' }
      },
      {
        path: '/sponsorships/metricas',
        name: 'Métricas Apadrinamiento',
        component: SponsorshipMetrics,
        meta: { permission: 'sponsorship-metrics:view' }
      },
      {
        path: '/business-relationships/plans',
        name: 'Plans',
        component: Plans,
        meta: { permission: 'plans:view' }
      },
      {
        path: '/business-relationships/plans/ranking',
        name: 'PlanRanking',
        component: PlanRanking,
        meta: { permission: 'plan-ranking:view' }
      },
      {
        path: '/contratos/ranking',
        name: 'ContractRanking',
        component: ContractRanking,
        meta: { permission: 'contract-ranking:view' }
      },
      {
        path: '/metricas/service-ranking',
        name: 'ServiceRanking',
        component: ServiceRanking,
        meta: { permission: 'service-ranking:view' }
      },
      {
        path: '/metricas/contract-profitability',
        name: 'ContractProfitability',
        component: ContractProfitability,
        meta: { permission: 'gross-margin:view' }
      },
      {
        path: '/metricas/cac-cltv',
        name: 'CacCltv',
        component: CacCltv,
        meta: { permission: 'cac-cltv:view' }
      },
      {
        path: '/metricas/b2c-cltv',
        name: 'B2cCltv',
        component: B2cCltv,
        meta: { permission: 'b2c-cltv:view' }
      },
      {
        path: '/metricas/mascotas-protegidas',
        name: 'MetricasMascotas',
        component: MetricasMascotas,
        meta: { permission: 'pet-protection-metrics:view' }
      },
      {
        path: '/metricas/contract-success',
        name: 'ContractSuccess',
        component: ContractSuccess,
        meta: { permission: 'customer-success:view' }
      },
      {
        path: '/metricas/new-mrr',
        name: 'NewMrrReport',
        component: NewMrrReport,
        meta: { permission: 'mrr-new:view' }
      },
      {
        path: '/metricas/renovaciones',
        name: 'Renovaciones',
        component: Renovaciones,
        meta: { permission: 'b2b-renewals:view' }
      },
      {
        path: '/business-relationships/plans/:planId',
        name: 'PlanDetails',
        component: PlanDetails,
        props: true,
        meta: { permission: 'plans:view' }
      },
      {
        path: '/business-relationships/companies',
        name: 'Empresas',
        component: Companies,
        meta: { permission: 'companies:view' }
      },
      {
        path: '/clients/org-charts',
        name: 'ClientOrgCharts',
        component: ClientOrgCharts,
        meta: { permission: 'client-org-charts:view' }
      },
      // Antes que la ruta con :pipedriveOrgId, para que "unassigned" no se lea como id.
      {
        path: '/clients/org-charts/unassigned',
        name: 'ClientOrgChartUnassigned',
        component: ClientOrgChartUnassigned,
        meta: { permission: 'client-org-charts:view' }
      },
      {
        path: '/clients/org-charts/:pipedriveOrgId',
        name: 'ClientOrgChartDetail',
        component: ClientOrgChartDetail,
        meta: { permission: 'client-org-charts:view' }
      },
      {
        path: '/opposition-requests',
        name: 'OppositionRequests',
        component: OppositionRequests,
        meta: { permission: 'arco-requests:view' }
      },
      {
        path: '/terms-notification',
        name: 'TermsNotification',
        component: TermsNotification,
        meta: { permission: 'terms-notification:view' }
      },
      {
        path: '/herramientas-internas/ranger-test-chat',
        name: 'Chat de prueba Ranger',
        component: InternalTools,
        meta: { permission: 'ranger-test-chat:use' }
      },
      {
        path: '/business-relationships/companies/:companyId',
        name: 'Empresas',
        component: CompanyDetails,
        props: true,
        meta: { permission: 'companies:view' }
      },
      {
        path: '/business-relationships/alliances',
        name: 'Club de Descuentos',
        component: ClubDescuentos,
        meta: { permission: 'discount-club:view' }
      },
      {
        path: '/business-relationships/poster-ads',
        name: 'Posters de beneficios',
        component: PosterAds,
        meta: { permission: 'poster-ads:view' }
      },
      {
        // Vista "Resumen MRR" deprecada (2026-10-07): no tenía entrada en el menú y
        // duplicaba MRR Resumen. La URL vieja redirige para no romper marcadores.
        path: '/finances/mrr',
        redirect: '/finances/metas'
      },
      {
        path: '/finances/mrr-detalle',
        name: 'MRR Detalle',
        component: MRRDetalle,
        meta: { permission: 'mrr-breakdown:view' }
      },
      {
        path: '/finances/mrr-daily',
        name: 'MRR Daily',
        component: MrrDaily,
        meta: { permission: 'mrr-resume:view' }
      },
      {
        path: '/finances/b2c-report-v2',
        name: 'Reporte B2C v2',
        component: B2CReportV2,
        meta: { permission: 'mrr-b2c-b2b2c:view' }
      },
      {
        path: '/finances/metas',
        name: 'Metas',
        component: Metas,
        meta: { permission: 'mrr-resume:view' }
      },
      {
        path: '/finances/tipo-cambio',
        name: 'Tasa de Cambio',
        component: TipoCambio,
        meta: { permission: 'exchange-rate:view' }
      },
      {
        path: '/finances/payments',
        name: 'Pagos recibidos',
        component: Payments,
        meta: { permission: 'users:view-payments' }
      },
      {
        path: '/registers/register-refunds',
        name: 'RegisterRefund',
        component: RegisterRefund,
        meta: { permission: 'register-refund:view' }
      },
      {
        path: '/registers/servicesrecords',
        name: 'Registro Servicios',
        component: ServicesRecords,
        // Each meta.permission must match its leaf in nav-sections.utils.js (specs 131/132).
        meta: { permission: ['service-records:read', 'service-records:read-own'] }
      },
      {
        path: '/refunds/new',
        name: 'Refunds2',
        component: RefundView,
        meta: { permission: 'refund-inbox:view' }
      },
      {
        path: '/refunds/clinics',
        name: 'RefundClinics',
        component: RefundClinics,
        meta: { permission: 'refund-clinics:view' }
      },
      {
        path: '/refunds/redirect-profiles',
        name: 'RefundRedirectProfiles',
        component: RefundRedirectProfiles,
        meta: { permission: 'refund-redirect-profiles:view' }
      },
      {
        path: '/users/:pgId',
        name: 'Vision360',
        component: Vision360,
        meta: { permission: 'users:view' }
      },
      {
        path: '/contratos',
        name: 'Contratos',
        component: Contratos,
        meta: { permission: 'contracts:view' }
      },
      {
        path: '/vencimientos',
        name: 'Vencimientos',
        component: Vencimientos,
        meta: { permission: 'b2c-renewals:view' }
      },
      {
        path: '/contratos/productos',
        name: 'Productos',
        component: Productos,
        meta: { permission: 'products:view' }
      },
      {
        path: '/mantenedores/lineas-negocio',
        name: 'LineasNegocio',
        component: LineasNegocio,
        meta: { permission: 'business-lines:view' }
      },
      {
        path: '/configuracion/brokers',
        name: 'Brokers',
        component: Brokers,
        meta: { permission: 'brokers:view' }
      },
      {
        path: '/mantenedores/respuestas-tipo',
        name: 'RespuestasTipo',
        component: RespuestasTipo,
        meta: { permission: 'refund-reply-templates:view' }
      },
      {
        path: '/mantenedores/servicios',
        name: 'Servicios',
        component: Servicios,
        meta: { permission: 'services:view' }
      },
      {
        path: '/configuracion/ejecutivos',
        name: 'Administradores',
        component: Ejecutivos,
        meta: { permission: 'admins:view' }
      },
      {
        path: '/finances/billing/individual',
        name: 'BillingIndividual',
        component: BillingIndividual,
        meta: { permission: 'mrr-billing-entry:create' }
      },
      {
        path: '/finances/billing/importar',
        name: 'BillingImportar',
        component: BillingImportar,
        meta: { permission: 'mrr-billing-import:import' }
      },
      {
        path: '/metricas/ces',
        name: 'Métricas CES',
        component: MetricasCES,
        meta: { permission: 'ces-metrics:view' }
      },
      {
        path: '/metricas/reembolsos',
        name: 'Métricas Reembolsos',
        component: MetricasReembolsos,
        meta: { permission: 'refund-metrics:view' }
      },
      {
        path: '/metricas/petmed',
        name: 'Métricas PetMed',
        component: MetricasPetmed,
        meta: { permission: 'petmed-metrics:view' }
      },
      {
        path: '/cargas-masivas',
        name: 'Cargas Masivas',
        component: CargasMasivas,
        meta: { permission: 'bulk-uploads:view' }
      },
      {
        path: '/renovacion-contrato',
        name: 'Renovación de Contrato',
        component: FullContractRenewal,
        meta: { permission: 'contract-renewal:view' }
      },
      {
        path: '/vetops/co-tutores',
        name: 'Co-tutores',
        component: CoTutores,
        meta: { permission: 'co-tutors:view' }
      },
      {
        path: '/cotizador',
        name: 'Cotizador',
        component: Cotizador,
        meta: { permission: 'quote-builder:view' }
      },
      {
        path: '/cotizador/:id',
        name: 'Editar cotización',
        component: Cotizador,
        meta: { permission: 'quote-builder:update' }
      },
      {
        path: '/cotizaciones',
        name: 'Cotizaciones',
        component: Cotizaciones,
        meta: { permission: ['quotes:view', 'quotes:view-own'] }
      },
      {
        path: '/cotizaciones/:id',
        name: 'Detalle de cotización',
        component: CotizacionDetalle,
        meta: { permission: ['quotes:view', 'quotes:view-own'] }
      },
      {
        path: '/finanzas/analisis-actuarial',
        name: 'AnalisisActuarial',
        component: AnalisisActuarial,
        meta: { permission: 'actuarial-analysis:view' }
      },
      {
        path: '/finanzas/facturacion-clinicas',
        name: 'ClinicBilling',
        component: ClinicBilling,
        meta: { permission: 'clinic-billing:view' }
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// Landing resolution (spec 028) and per-admin permission check (spec 131).
router.beforeEach(permissionGuard);

// Google Analytics GA4 — registra cada cambio de sección
router.afterEach((to) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_title: to.name || to.path,
      page_path: to.path,
    });
  }
});

export default router;
